(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoCURegenerarService', ReporteEvaluativoCURegenerarService);

    ReporteEvaluativoCURegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoCURegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteCU:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreportecuregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();